export var AdvancedExportStatuses;
(function (AdvancedExportStatuses) {
    AdvancedExportStatuses["ARCHIVED"] = "ARCHIVED";
    AdvancedExportStatuses["READY"] = "READY";
    AdvancedExportStatuses["PAUSED"] = "PAUSED";
    AdvancedExportStatuses["DRAFT"] = "DRAFT";
    AdvancedExportStatuses["CANCELLED"] = "CANCELLED";
})(AdvancedExportStatuses || (AdvancedExportStatuses = {}));
//# sourceMappingURL=templates.js.map